import { AppDispatch, AppGetState } from "../store";
import { getUserInfoUsingGlobalLevelToken } from "../redux/accessTokenManagerActions";
import { persistUserInfo } from "../redux/modules/user/reducer";
import { redirectToSigninPage } from "../redux/redirectToSigninPage";

export const userOpensBackofficeWebapp = () => async (
  dispatch: AppDispatch,
  getState: AppGetState,
): Promise<void> => {
  try {
    const userInfo = await dispatch(getUserInfoUsingGlobalLevelToken());
    dispatch(persistUserInfo(userInfo));
  } catch {
    await dispatch(redirectToSigninPage());
  }
};
